export default (store, childRoutes) => ({
  path:'/all_users',
  getComponent (nextState, cb) {
    require.ensure([], (require) => {
      const AllUsers = require('./components').default
      cb(null, AllUsers)
    }, 'all_users')
  }
})



// WEBPACK FOOTER //
// ./src/routes/AllUsers/index.js